"use client"

import { Warehouse } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `WarehouseIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const WarehouseIcon = component(Icon)({ as: Warehouse })
